import { z } from 'zod';
// ─── Planning Status ────────────────────────────────────────────────────────
export const createPlanningStatusSchema = z.object({
    name: z.string().min(1).max(255),
    nameHe: z.string().max(255).optional(),
    color: z.string().max(7).optional(),
    sortOrder: z.number().int().optional(),
});
export const updatePlanningStatusSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    nameHe: z.string().max(255).nullable().optional(),
    color: z.string().max(7).nullable().optional(),
    sortOrder: z.number().int().optional(),
    isActive: z.boolean().optional(),
});
// ─── Planning Todo ──────────────────────────────────────────────────────────
export const createPlanningTodoSchema = z.object({
    title: z.string().min(1).max(500),
    isDone: z.boolean().optional(),
    status: z.enum(['TODO', 'IN_PROGRESS', 'DONE', 'BLOCKED']).optional(),
    dueDate: z.string().optional(),
    dueDateOffsetDays: z.number().int().nullable().optional(),
    assignedToUserId: z.string().uuid().optional(),
    notes: z.string().max(2000).optional(),
    sortOrder: z.number().int().optional(),
});
export const updatePlanningTodoSchema = z.object({
    title: z.string().min(1).max(500).optional(),
    isDone: z.boolean().optional(),
    status: z.enum(['TODO', 'IN_PROGRESS', 'DONE', 'BLOCKED']).optional(),
    dueDate: z.string().nullable().optional(),
    dueDateOffsetDays: z.number().int().nullable().optional(),
    assignedToUserId: z.string().uuid().nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
    sortOrder: z.number().int().optional(),
});
// ─── Planning Item ──────────────────────────────────────────────────────────
export const createPlanningItemSchema = z.object({
    vendorCategoryId: z.string().uuid().nullable().optional(),
    catalogItemId: z.string().uuid().nullable().optional(),
    itemName: z.string().max(500).optional(),
    quantity: z.number().nonnegative().optional(),
    roomId: z.string().uuid().nullable().optional(),
    expenseItemId: z.string().uuid().nullable().optional(),
    unitPrice: z.number().optional(),
    statusId: z.string().uuid().nullable().optional(),
    notes: z.string().max(2000).optional(),
    sortOrder: z.number().int().optional(),
    todos: z.array(createPlanningTodoSchema).optional(),
});
export const updatePlanningItemSchema = z.object({
    vendorCategoryId: z.string().uuid().nullable().optional(),
    catalogItemId: z.string().uuid().nullable().optional(),
    itemName: z.string().max(500).nullable().optional(),
    quantity: z.number().nonnegative().optional(),
    roomId: z.string().uuid().nullable().optional(),
    expenseItemId: z.string().uuid().nullable().optional(),
    unitPrice: z.number().optional(),
    statusId: z.string().uuid().nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
    sortOrder: z.number().int().optional(),
});
// ─── Planning List ──────────────────────────────────────────────────────────
export const createPlanningListSchema = z.object({
    eventId: z.string().uuid().optional(),
    eventTypeId: z.string().uuid().optional(),
    isTemplate: z.boolean().optional(),
    templateName: z.string().max(255).optional(),
    title: z.string().max(500).optional(),
    description: z.string().max(2000).optional(),
    items: z.array(createPlanningItemSchema).optional(),
});
export const updatePlanningListSchema = z.object({
    title: z.string().max(500).nullable().optional(),
    templateName: z.string().max(255).nullable().optional(),
    description: z.string().max(2000).nullable().optional(),
    eventTypeId: z.string().uuid().nullable().optional(),
});
export const clonePlanningListSchema = z.object({
    eventId: z.string().uuid().optional(),
    title: z.string().max(500).optional(),
});
export const savePlanningListAsTemplateSchema = z.object({
    templateName: z.string().min(1).max(255),
    eventTypeId: z.string().uuid().optional(),
});
//# sourceMappingURL=planning.js.map